<template>
  <Dialog v-model="dialogVisible" :title="approved ? '审核通过' : '审核拒绝'" width="480px">
    <el-form ref="formRef" v-loading="formLoading" :model="formData" label-width="90px">
      <el-form-item label="股东">
        <span>{{ row?.nickname || row?.userId }}</span>
      </el-form-item>
      <el-form-item label="审核备注">
        <el-input v-model="formData.auditReason" type="textarea" :rows="3" placeholder="可选" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button :disabled="formLoading" type="primary" @click="submit">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import * as UserApi from '@/api/mall/trade/shareholder/user'

defineOptions({ name: 'ShareholderUserAuditForm' })
const emit = defineEmits(['success'])
const message = useMessage()
const dialogVisible = ref(false)
const formLoading = ref(false)
const approved = ref(true)
const row = ref<UserApi.ShareholderUserVO>()
const formData = ref({ auditReason: '' })

const open = (r: UserApi.ShareholderUserVO, ok: boolean) => {
  row.value = r
  approved.value = ok
  formData.value = { auditReason: '' }
  dialogVisible.value = true
}

const submit = async () => {
  formLoading.value = true
  try {
    await UserApi.auditShareholderUser({
      id: row.value!.id!,
      approved: approved.value,
      auditReason: formData.value.auditReason
    })
    message.success('审核完成')
    dialogVisible.value = false
    emit('success')
  } finally {
    formLoading.value = false
  }
}

defineExpose({ open })
</script>
